import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { STRATEGY_NAMEMAPPING } from 'src/components/Strategy/constants';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

interface StrategyTypeButtonProps {
  onTypeSelect: (type: string) => void;
  strategyType: string;
  isSelected: boolean;
  disabled?: boolean;
  disabledReason?: string;
  description: string;
  icon: IconProp;
}

const StrategyTypeButton: React.FC<StrategyTypeButtonProps> = ({
  onTypeSelect,
  strategyType,
  isSelected,
  disabled = false,
  disabledReason,
  description,
  icon,
}) => {
  return (
    <button
      type="button"
      onClick={() => !disabled && onTypeSelect(strategyType)}
      disabled={disabled}
      className={`h-24 p-4 border rounded-xl text-left transition-all duration-200 ${
        disabled
          ? 'border-neutral-200 bg-neutral-50 cursor-not-allowed opacity-60 relative'
          : isSelected
          ? 'border-sky-500 bg-sky-50 shadow-md'
          : 'border-neutral-200 bg-white hover:bg-neutral-50 hover:shadow-sm'
      }`}
    >
      {disabled && disabledReason && (
        <div className="absolute top-2 right-2 bg-orange-500 text-white text-xs px-2 py-1 rounded shadow-sm">
          {disabledReason}
        </div>
      )}

      <div className="flex items-start gap-3">
        <div
          className={`w-8 h-8 rounded-lg flex items-center justify-center ${
            isSelected
              ? 'bg-sky-500 text-white'
              : 'bg-neutral-100 text-neutral-600'
          }`}
        >
          <Icon icon={icon} className="w-4 h-4" />
        </div>
        <div className="flex-1 min-w-0 flex flex-col gap-1">
          <h4
            className={`font-semibold text-sm truncate ${
              isSelected ? 'text-sky-600' : 'text-primary'
            }`}
          >
            {STRATEGY_NAMEMAPPING[strategyType]}
          </h4>
          <p
            className={`text-xs leading-relaxed line-clamp-2 ${
              isSelected ? 'text-sky-600' : 'text-neutral-500'
            }`}
          >
            {description}
          </p>
        </div>
        {isSelected && (
          <div className="w-5 h-5 rounded-full bg-sky-500 text-white flex items-center justify-center text-xs">
            <Icon icon={faCheck} className="w-3 h-3" />
          </div>
        )}
      </div>
    </button>
  );
};

export default StrategyTypeButton;
